import axios from '../../helpers/interceptors';

import {
    TEST,
    SET_MOBILE_NAV_STATUS,
    GET_USER_DATA_STARTED,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_FAILURE,
    SET_TOPUP_MODAL_STATUS,
    GET_DIRECT_TOPUP_INFO_STARTED,
    GET_DIRECT_TOPUP_INFO_SUCCESS,
    GET_DIRECT_TOPUP_INFO_FAILURE,
    CREATE_DIRECT_TOPUP_STARTED,
    CREATE_DIRECT_TOPUP_SUCCESS,
    CREATE_DIRECT_TOPUP_FAILURE,
    GET_DIRECT_TOPUP_STARTED,
    GET_DIRECT_TOPUP_SUCCESS,
    GET_DIRECT_TOPUP_FAILURE,
    CANCEL_DIRECT_TOPUP_STARTED,
    CANCEL_DIRECT_TOPUP_SUCCESS,
    CANCEL_DIRECT_TOPUP_FAILURE,
    GET_DASHBOARD_STARTED,
    GET_DASHBOARD_SUCCESS,
    GET_DASHBOARD_FAILURE,
    GET_SYSTEM_UPDATES_STARTED,
    GET_SYSTEM_UPDATES_SUCCESS,
    GET_SYSTEM_UPDATES_FAILURE,
    GET_NOTIFICATIONS_STARTED,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_FAILURE,
    READ_NOTIFICATION_SUCCESS,
    READ_ALL_NOTIFICATIONS_SUCCESS,
    GET_WITHDRAW_INFO_STARTED,
    GET_WITHDRAW_INFO_SUCCESS,
    GET_WITHDRAW_INFO_FAILURE,
    CREATE_WITHDRAW_STARTED,
    CREATE_WITHDRAW_SUCCESS,
    CREATE_WITHDRAW_FAILURE,
    GET_WITHDRAWS_STARTED,
    GET_WITHDRAWS_SUCCESS,
    GET_WITHDRAWS_FAILURE,
    CANCEL_WITHDRAW_STARTED,
    CANCEL_WITHDRAW_SUCCESS,
    CANCEL_WITHDRAW_FAILURE,
    SET_WITHDRAW_MODAL_STATUS,
    SET_REFERRAL_WITHDRAW_MODAL_STATUS,
    GET_REFERRAL_WITHDRAW_INFO_STARTED,
    GET_REFERRAL_WITHDRAW_INFO_SUCCESS,
    GET_REFERRAL_WITHDRAW_INFO_FAILURE,
    CREATE_REFERRAL_WITHDRAW_STARTED,
    CREATE_REFERRAL_WITHDRAW_SUCCESS,
    CREATE_REFERRAL_WITHDRAW_FAILURE,
    GET_REFERRAL_WITHDRAWS_STARTED,
    GET_REFERRAL_WITHDRAWS_SUCCESS,
    GET_REFERRAL_WITHDRAWS_FAILURE,
    CANCEL_REFERRAL_WITHDRAW_STARTED,
    CANCEL_REFERRAL_WITHDRAW_SUCCESS,
    GET_REFERRAL_TRANSFERS_STARTED,
    GET_REFERRAL_TRANSFERS_SUCCESS,
    GET_REFERRAL_TRANSFERS_FAILURE,
    CANCEL_REFERRAL_TRANSFER_STARTED,
    CANCEL_REFERRAL_TRANSFER_SUCCESS,
    CANCEL_REFERRAL_TRANSFER_FAILURE,
    SET_REFERRAL_TRANSFER_MODAL_STATUS,
    SET_REFERRAL_TRANSFERS_MODAL_STATUS,
    REQUEST_EARLY_ACCESS_STARTED,
    REQUEST_EARLY_ACCESS_SUCCESS,
    REQUEST_EARLY_ACCESS_FAILURE,
    SET_STORAGE_MODAL_STATUS,
    GET_STORAGE_STARTED,
    GET_STORAGE_SUCCESS,
    GET_STORAGE_FAILURE,
    GET_STORAGE_PACKAGES_STARTED,
    GET_STORAGE_PACKAGES_SUCCESS,
    GET_STORAGE_PACKAGES_FAILURE,
    CREATE_STORAGE_PURCHASE_STARTED,
    CREATE_STORAGE_PURCHASE_SUCCESS,
    CREATE_STORAGE_PURCHASE_FAILURE,
    GET_STORAGE_PURCHASE_SUCCESS,
    CANCEL_STORAGE_PURCHASE_SUCCESS,
    GET_AVATAR_STARTED,
    GET_AVATAR_SUCCESS,
    GET_AVATAR_FAILURE,
    GET_VOICE_STARTED,
    GET_VOICE_SUCCESS,
    GET_VOICE_FAILURE,
    UPLOAD_VOICE_STARTED,
    UPLOAD_VOICE_SUCCESS,
    UPLOAD_VOICE_FAILURE,
    GET_ENERGY_STARTED,
    GET_ENERGY_SUCCESS,
    GET_ENERGY_FAILURE,
    UNLOCK_ENERGY_STARTED,
    UNLOCK_ENERGY_SUCCESS,
    UNLOCK_ENERGY_FAILURE,
    GET_METAPERSON_STARTED,
    GET_METAPERSON_SUCCESS,
    GET_METAPERSON_FAILURE,
    IMPORT_AVATAR_STARTED,
    IMPORT_AVATAR_SUCCESS,
    IMPORT_AVATAR_FAILURE,
    GET_ENERGY_PACKAGES_STARTED,
    GET_ENERGY_PACKAGES_SUCCESS,
    GET_ENERGY_PACKAGES_FAILURE,
    CREATE_ENERGY_PURCHASE_STARTED,
    CREATE_ENERGY_PURCHASE_SUCCESS,
    CREATE_ENERGY_PURCHASE_FAILURE,
    GET_ENERGY_PURCHASE_SUCCESS,
    CANCEL_ENERGY_PURCHASE_SUCCESS,
    ASK_CONVERSATION_STARTED,
    ASK_CONVERSATION_SUCCESS,
    ASK_CONVERSATION_FAILURE,
    SPEAK_CONVERSATION_STARTED,
    SPEAK_CONVERSATION_SUCCESS,
    SPEAK_CONVERSATION_FAILURE,
    GET_CONVERSATIONS_STARTED,
    GET_CONVERSATIONS_SUCCESS,
    GET_CONVERSATIONS_FAILURE,
    GET_CONVERSATION_STARTED,
    GET_CONVERSATION_SUCCESS,
    GET_CONVERSATION_FAILURE,
    SEAL_CAPSULE_STARTED,
    SEAL_CAPSULE_SUCCESS,
    SEAL_CAPSULE_FAILURE,
    SET_SEAL_MODAL_STATUS,
    SET_UNLOCK_MODAL_STATUS,
    SET_ENERGY_MODAL_STATUS,
    SET_CREATOR_STATUS,
    CREATE_TOPUP_STARTED,
    CREATE_TOPUP_SUCCESS,
    CREATE_TOPUP_FAILURE,
    GET_TOPUP_STATUS_STARTED,
    GET_TOPUP_STATUS_SUCCESS,
    GET_TOPUP_STATUS_FAILURE,
    CANCEL_TOPUP_STARTED,
    CANCEL_TOPUP_SUCCESS,
    CANCEL_TOPUP_FAILURE,
    GET_PRE_SALE_MAIN_STARTED,
    GET_PRE_SALE_MAIN_SUCCESS,
    GET_PRE_SALE_MAIN_FAILURE,
    SET_PRE_SALE_BUY_MODAL_STATUS,
    SET_SETTINGS_CHANGE_PASSWORD_MODAL_STATUS,
    CHANGE_PASSWORD_STARTED,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    SET_SETTINGS_CHANGE_WALLET_MODAL_STATUS,
    CHANGE_WALLET_STARTED,
    CHANGE_WALLET_SUCCESS,
    CHANGE_WALLET_FAILURE,
    GET_BUY_TOKEN_DATA_STARTED,
    GET_BUY_TOKEN_DATA_SUCCESS,
    GET_BUY_TOKEN_DATA_FAILURE,
    SET_SETTINGS_CHANGE_EMAIL_MODAL_STATUS,
    CHANGE_EMAIL_STARTED,
    CHANGE_EMAIL_SUCCESS,
    CHANGE_EMAIL_FAILURE,
    GET_LAST_LOG_STARTED,
    GET_LAST_LOG_SUCCESS,
    GET_LAST_LOG_FAILURE,
    LOGOUT_STARTED,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,
    LOGOUT_OTHERS_STARTED,
    LOGOUT_OTHERS_SUCCESS,
    LOGOUT_OTHERS_FAILURE,
    GET_ORDER_HISTORY_STARTED,
    GET_ORDER_HISTORY_SUCCESS,
    GET_ORDER_HISTORY_FAILURE,
    GET_ACTIVE_ORDER_STARTED,
    GET_ACTIVE_ORDER_SUCCESS,
    GET_ACTIVE_ORDER_FAILURE,
    CANCEL_ORDER_STARTED,
    CANCEL_ORDER_SUCCESS,
    CANCEL_ORDER_FAILURE,
    GET_REFERRALS_STARTED,
    GET_REFERRALS_SUCCESS,
    GET_REFERRALS_FAILURE,
    SET_REFERRER_STARTED,
    SET_REFERRER_SUCCESS,
    SET_REFERRER_FAILURE,
    SET_CAPSULE_QUESTIONNAIRE_MODAL_STATUS,
    SET_CAPSULE_NOTES_MODAL_STATUS,
    SET_CAPSULE_FILES_MODAL_STATUS,
    SET_CAPSULE_BUY_MODAL_STATUS,
    GET_CAPSULE_OFFER_STARTED,
    GET_CAPSULE_OFFER_SUCCESS,
    GET_CAPSULE_OFFER_FAILURE,
    PURCHASE_CAPSULE_STARTED,
    PURCHASE_CAPSULE_SUCCESS,
    PURCHASE_CAPSULE_FAILURE,
    GET_CAPSULE_STATS_STARTED,
    GET_CAPSULE_STATS_SUCCESS,
    GET_CAPSULE_STATS_FAILURE,
    GET_QUESTIONNAIRE_STARTED,
    GET_QUESTIONNAIRE_SUCCESS,
    GET_QUESTIONNAIRE_FAILURE,
    SAVE_BLOCK_ANSWERS_STARTED,
    SAVE_BLOCK_ANSWERS_SUCCESS,
    SAVE_BLOCK_ANSWERS_FAILURE,
    GET_CAPSULE_NOTES_STARTED,
    GET_CAPSULE_NOTES_SUCCESS,
    GET_CAPSULE_NOTES_FAILURE,
    SAVE_CAPSULE_NOTE_STARTED,
    SAVE_CAPSULE_NOTE_SUCCESS,
    SAVE_CAPSULE_NOTE_FAILURE,
    DELETE_CAPSULE_NOTE_STARTED,
    DELETE_CAPSULE_NOTE_SUCCESS,
    DELETE_CAPSULE_NOTE_FAILURE,
    GET_CAPSULE_FILES_STARTED,
    GET_CAPSULE_FILES_SUCCESS,
    GET_CAPSULE_FILES_FAILURE,
    UPLOAD_CAPSULE_FILE_STARTED,
    UPLOAD_CAPSULE_FILE_SUCCESS,
    UPLOAD_CAPSULE_FILE_FAILURE,
    SET_CAPSULE_FILE_UPLOAD_PROGRESS,
    DELETE_CAPSULE_FILE_STARTED,
    DELETE_CAPSULE_FILE_SUCCESS,
    DELETE_CAPSULE_FILE_FAILURE
} from "./types";

import {api} from "../../api";
import {setAuthorizationStatus} from "../main/action";

// import {toast} from "react-toastify";
const host = api.host;

// Для multipart Content-Type ставить руками нельзя — axios сам добавит
// boundary, без которого сервер не разберёт тело
const headWTFD = ()=>{
    const token = localStorage.getItem('tc-token');
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
        }
    }
}

const headWT = ()=>{
    const token = localStorage.getItem('tc-token');
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
}
//
// const headWTFD = ()=>{
//     const token = localStorage.getItem('oli-token');
//     return {
//         headers: {
//             'Authorization': `Bearer ${token}`,
//             'Accept': 'application/json'
//         }
//     }
// }

export const test = data => ({
    type: TEST,
    payload: data
});

export const setMobileNavStatus = status => ({
    type: SET_MOBILE_NAV_STATUS,
    payload: status
});

export const getUserData = () => {
    let url = host + api.cabinet.userData;


    return dispatch => {
        dispatch(getUserDataStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getUserDataSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getUserDataFailure(err));
            });
    };
};

const getUserDataStarted = () => ({
    type: GET_USER_DATA_STARTED
});

export const getUserDataSuccess = serverReport => ({
    type: GET_USER_DATA_SUCCESS,
    payload: serverReport
});

export const getUserDataFailure = error => ({
    type: GET_USER_DATA_FAILURE,
    payload: error
});


export const getPreSaleMain = () => {
    let url = host + api.cabinet.preSaleMain;


    return dispatch => {
        dispatch(getPreSaleMainStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getPreSaleMainSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getPreSaleMainFailure(err));
            });
    };
};

const getPreSaleMainStarted = () => ({
    type: GET_PRE_SALE_MAIN_STARTED
});

export const getPreSaleMainSuccess = serverReport => ({
    type: GET_PRE_SALE_MAIN_SUCCESS,
    payload: serverReport
});

export const getPreSaleMainFailure = error => ({
    type: GET_PRE_SALE_MAIN_FAILURE,
    payload: error
});

export const setPreSaleBuyModalStatus = status => ({
    type: SET_PRE_SALE_BUY_MODAL_STATUS,
    payload: status
});

export const setSettingsChangePasswordModalStatus = status => ({
    type: SET_SETTINGS_CHANGE_PASSWORD_MODAL_STATUS,
    payload: status
});

export const changePassword = (data, successHandler) => {
    let url = host + api.cabinet.changePassword;

    return dispatch => {
        dispatch(changePasswordStarted());
        axios.put(url, data, headWT())
            .then(res => {
                dispatch(changePasswordSuccess(res.data.success));
                successHandler();
            })
            .catch(err => {
                dispatch(changePasswordFailure(err.response.data.errors));
            });
    };
};

const changePasswordStarted = () => ({
    type: CHANGE_PASSWORD_STARTED
});

export const changePasswordSuccess = serverReport => ({
    type: CHANGE_PASSWORD_SUCCESS,
    payload: serverReport
});

export const changePasswordFailure = error => ({
    type: CHANGE_PASSWORD_FAILURE,
    payload: error
});

export const setSettingsChangeWalletModalStatus = status => ({
    type: SET_SETTINGS_CHANGE_WALLET_MODAL_STATUS,
    payload: status
});


export const changeWallet = (data, successHandler) => {
    let url = host + api.cabinet.changeWallet;

    return dispatch => {
        dispatch(changeWalletStarted());
        axios.put(url, data, headWT())
            .then(res => {
                dispatch(changeWalletSuccess(res.data.success));
                dispatch(getUserData());
                successHandler();
            })
            .catch(err => {
                dispatch(changeWalletFailure(err.response.data.errors));
            });
    };
};

const changeWalletStarted = () => ({
    type: CHANGE_WALLET_STARTED
});

export const changeWalletSuccess = serverReport => ({
    type: CHANGE_WALLET_SUCCESS,
    payload: serverReport
});

export const changeWalletFailure = error => ({
    type: CHANGE_WALLET_FAILURE,
    payload: error
});


export const getBuyTokenData = (data) => {
    let url = host + api.cabinet.buyTokenData;

    return dispatch => {
        dispatch(getBuyTokenDataStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(getBuyTokenDataSuccess(res.data.response));
                dispatch(getOrderHistory());
                dispatch(setPreSaleBuyModalStatus(true));
            })
            .catch(err => {
                dispatch(getBuyTokenDataFailure(err));
            });
    };
};

const getBuyTokenDataStarted = () => ({
    type: GET_BUY_TOKEN_DATA_STARTED
});

export const getBuyTokenDataSuccess = serverReport => ({
    type: GET_BUY_TOKEN_DATA_SUCCESS,
    payload: serverReport
});

export const getBuyTokenDataFailure = error => ({
    type: GET_BUY_TOKEN_DATA_FAILURE,
    payload: error
});


export const setSettingsChangeEmailModalStatus = status => ({
    type: SET_SETTINGS_CHANGE_EMAIL_MODAL_STATUS,
    payload: status
});


export const changeEmail = (data, successHandler) => {
    let url = host + api.cabinet.changeEmail;

    return dispatch => {
        dispatch(changeEmailStarted());
        axios.put(url, data, headWT())
            .then(res => {
                dispatch(changeEmailSuccess(res.data.success));
                successHandler();
            })
            .catch(err => {
                dispatch(changeEmailFailure(err.response.data.errors));
            });
    };
};

const changeEmailStarted = () => ({
    type: CHANGE_EMAIL_STARTED
});

export const changeEmailSuccess = serverReport => ({
    type: CHANGE_EMAIL_SUCCESS,
    payload: serverReport
});

export const changeEmailFailure = error => ({
    type: CHANGE_EMAIL_FAILURE,
    payload: error
});


export const getLastLog = () => {
    let url = host + api.cabinet.lastLog;

    return dispatch => {
        dispatch(getLastLogStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getLastLogSuccess(res.data.response));
            })
            .catch(err => {
                dispatch(getLastLogFailure(err.response.data.errors));
            });
    };
};

const getLastLogStarted = () => ({
    type: GET_LAST_LOG_STARTED
});

export const getLastLogSuccess = serverReport => ({
    type: GET_LAST_LOG_SUCCESS,
    payload: serverReport
});

export const getLastLogFailure = error => ({
    type: GET_LAST_LOG_FAILURE,
    payload: error
});


export const logout = () => {
    let url = host + api.cabinet.logout;

    return dispatch => {
        dispatch(logoutStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(logoutSuccess(res));
                localStorage.removeItem('tc-token');
                dispatch(setAuthorizationStatus(false));
                // dispatch(clearCabinetState());
            })
            .catch(err => {
                localStorage.removeItem('tc-token');
                dispatch(setAuthorizationStatus(false));
                dispatch(logoutFailure(err));
                // dispatch(clearCabinetState());
            });
    };
};

const logoutStarted = () => ({
    type: LOGOUT_STARTED
});

export const logoutSuccess = serverReport => ({
    type: LOGOUT_SUCCESS,
    payload: serverReport
});

export const logoutFailure = error => ({
    type: LOGOUT_FAILURE,
    payload: error
});



export const logoutOthers = (successHandler) => {
    let url = host + api.cabinet.logoutOthers;

    return dispatch => {
        dispatch(logoutOthersStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(logoutOthersSuccess(res));
                dispatch(getLastLog());
                successHandler();
            })
            .catch(err => {
                dispatch(logoutOthersFailure(err));
            });
    };
};

const logoutOthersStarted = () => ({
    type: LOGOUT_OTHERS_STARTED
});

export const logoutOthersSuccess = serverReport => ({
    type: LOGOUT_OTHERS_SUCCESS,
    payload: serverReport
});

export const logoutOthersFailure = error => ({
    type: LOGOUT_OTHERS_FAILURE,
    payload: error
});


export const getOrderHistory = () => {
    let url = host + api.cabinet.orderHistory + `?per_page=50`;

    return dispatch => {
        dispatch(getOrderHistoryStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getOrderHistorySuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getOrderHistoryFailure(err));
            });
    };
};

const getOrderHistoryStarted = () => ({
    type: GET_ORDER_HISTORY_STARTED
});

export const getOrderHistorySuccess = serverReport => ({
    type: GET_ORDER_HISTORY_SUCCESS,
    payload: serverReport
});

export const getOrderHistoryFailure = error => ({
    type: GET_ORDER_HISTORY_FAILURE,
    payload: error
});


export const getActiveOrder = (id) => {
    let url = host + api.cabinet.activeOrder + `/${id}/status`;

    return dispatch => {
        dispatch(getActiveOrderStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getActiveOrderSuccess(res?.data?.response));
                dispatch(getBuyTokenDataSuccess(res.data.response));
                dispatch(setPreSaleBuyModalStatus(true));
            })
            .catch(err => {
                dispatch(getActiveOrderFailure(err));
            });
    };
};

const getActiveOrderStarted = () => ({
    type: GET_ACTIVE_ORDER_STARTED
});

export const getActiveOrderSuccess = serverReport => ({
    type: GET_ACTIVE_ORDER_SUCCESS,
    payload: serverReport
});

export const getActiveOrderFailure = error => ({
    type: GET_ACTIVE_ORDER_FAILURE,
    payload: error
});


export const cancelOrder = (id, successHandler) => {
    let url = host + api.cabinet.activeOrder + `/${id}/cancel`;

    return dispatch => {
        dispatch(cancelOrderStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(cancelOrderSuccess(res));
                dispatch(getOrderHistory());
                successHandler();
            })
            .catch(err => {
                dispatch(cancelOrderFailure(err));
            });
    };
};

const cancelOrderStarted = () => ({
    type: CANCEL_ORDER_STARTED
});

export const cancelOrderSuccess = serverReport => ({
    type: CANCEL_ORDER_SUCCESS,
    payload: serverReport
});

export const cancelOrderFailure = error => ({
    type: CANCEL_ORDER_FAILURE,
    payload: error
});


export const getReferrals = () => {
    let url = host + api.cabinet.referrals;

    return dispatch => {
        dispatch(getReferralsStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getReferralsSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getReferralsFailure(err));
            });
    };
};

const getReferralsStarted = () => ({
    type: GET_REFERRALS_STARTED
});

export const getReferralsSuccess = serverReport => ({
    type: GET_REFERRALS_SUCCESS,
    payload: serverReport
});

export const getReferralsFailure = error => ({
    type: GET_REFERRALS_FAILURE,
    payload: error
});


// Указать пригласителя после регистрации — для тех, кто не ввёл код при
// создании аккаунта. Разрешено один раз и только пока у пользователя нет
// пригласителя и он сам никого не пригласил: признак приходит в
// can_set_referrer у GET /user/referrals
export const setReferrer = (code, successHandler, failHandler) => {
    let url = host + api.cabinet.setReferrer;

    return dispatch => {
        dispatch({type: SET_REFERRER_STARTED});
        axios.post(url, {referral_code: code}, headWT())
            .then(res => {
                dispatch({type: SET_REFERRER_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: SET_REFERRER_FAILURE, payload: err?.response?.data});
                if (failHandler) {
                    failHandler(err?.response?.data, err?.response?.status);
                }
            });
    };
};


// ---------------------------------------------------------------------------
// Капсула: статистика, анкета, заметки, памятные материалы
// ---------------------------------------------------------------------------

export const setCapsuleQuestionnaireModalStatus = data => ({
    type: SET_CAPSULE_QUESTIONNAIRE_MODAL_STATUS,
    payload: data
});

export const setCapsuleNotesModalStatus = data => ({
    type: SET_CAPSULE_NOTES_MODAL_STATUS,
    payload: data
});

export const setCapsuleFilesModalStatus = data => ({
    type: SET_CAPSULE_FILES_MODAL_STATUS,
    payload: data
});

export const setCapsuleBuyModalStatus = data => ({
    type: SET_CAPSULE_BUY_MODAL_STATUS,
    payload: data
});


export const getCapsuleStats = () => {
    let url = host + api.cabinet.capsuleStats;

    return dispatch => {
        dispatch(getCapsuleStatsStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getCapsuleStatsSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getCapsuleStatsFailure(err));
            });
    };
};

const getCapsuleStatsStarted = () => ({
    type: GET_CAPSULE_STATS_STARTED
});

export const getCapsuleStatsSuccess = serverReport => ({
    type: GET_CAPSULE_STATS_SUCCESS,
    payload: serverReport
});

export const getCapsuleStatsFailure = error => ({
    type: GET_CAPSULE_STATS_FAILURE,
    payload: error
});


export const getQuestionnaire = () => {
    let url = host + api.cabinet.questionnaire;

    return dispatch => {
        dispatch(getQuestionnaireStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getQuestionnaireSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getQuestionnaireFailure(err));
            });
    };
};

const getQuestionnaireStarted = () => ({
    type: GET_QUESTIONNAIRE_STARTED
});

export const getQuestionnaireSuccess = serverReport => ({
    type: GET_QUESTIONNAIRE_SUCCESS,
    payload: serverReport
});

export const getQuestionnaireFailure = error => ({
    type: GET_QUESTIONNAIRE_FAILURE,
    payload: error
});


// answers: [{question_id, answer}] одного блока
export const saveBlockAnswers = (blockId, answers, successHandler) => {
    let url = host + api.cabinet.questionBlocks + `/${blockId}/answers`;

    return dispatch => {
        dispatch(saveBlockAnswersStarted());
        axios.put(url, {answers}, headWT())
            .then(res => {
                dispatch(saveBlockAnswersSuccess(res?.data?.response));
                // прогресс капсулы пересчитывается на бэке — тянем свежий
                dispatch(getCapsuleStats());
                dispatch(getQuestionnaire());
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch(saveBlockAnswersFailure(err?.response?.data));
            });
    };
};

const saveBlockAnswersStarted = () => ({
    type: SAVE_BLOCK_ANSWERS_STARTED
});

export const saveBlockAnswersSuccess = serverReport => ({
    type: SAVE_BLOCK_ANSWERS_SUCCESS,
    payload: serverReport
});

export const saveBlockAnswersFailure = error => ({
    type: SAVE_BLOCK_ANSWERS_FAILURE,
    payload: error
});


export const getCapsuleNotes = () => {
    let url = host + api.cabinet.capsuleNotes;

    return dispatch => {
        dispatch(getCapsuleNotesStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getCapsuleNotesSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getCapsuleNotesFailure(err));
            });
    };
};

const getCapsuleNotesStarted = () => ({
    type: GET_CAPSULE_NOTES_STARTED
});

export const getCapsuleNotesSuccess = serverReport => ({
    type: GET_CAPSULE_NOTES_SUCCESS,
    payload: serverReport
});

export const getCapsuleNotesFailure = error => ({
    type: GET_CAPSULE_NOTES_FAILURE,
    payload: error
});


// id не передан — создаём новую заметку, передан — правим существующую
export const saveCapsuleNote = (id, text, successHandler) => {
    let url = host + api.cabinet.capsuleNotes + (id ? `/${id}` : '');

    return dispatch => {
        dispatch(saveCapsuleNoteStarted());
        const request = id
            ? axios.put(url, {text}, headWT())
            : axios.post(url, {text}, headWT());

        request
            .then(res => {
                dispatch(saveCapsuleNoteSuccess(res?.data?.response));
                dispatch(getCapsuleNotes());
                dispatch(getCapsuleStats());
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch(saveCapsuleNoteFailure(err?.response?.data));
            });
    };
};

const saveCapsuleNoteStarted = () => ({
    type: SAVE_CAPSULE_NOTE_STARTED
});

export const saveCapsuleNoteSuccess = serverReport => ({
    type: SAVE_CAPSULE_NOTE_SUCCESS,
    payload: serverReport
});

export const saveCapsuleNoteFailure = error => ({
    type: SAVE_CAPSULE_NOTE_FAILURE,
    payload: error
});


export const deleteCapsuleNote = (id, successHandler) => {
    let url = host + api.cabinet.capsuleNotes + `/${id}`;

    return dispatch => {
        dispatch(deleteCapsuleNoteStarted());
        axios.delete(url, headWT())
            .then(res => {
                dispatch(deleteCapsuleNoteSuccess(res?.data?.response));
                dispatch(getCapsuleNotes());
                dispatch(getCapsuleStats());
                if (successHandler) {
                    successHandler();
                }
            })
            .catch(err => {
                dispatch(deleteCapsuleNoteFailure(err?.response?.data));
            });
    };
};

const deleteCapsuleNoteStarted = () => ({
    type: DELETE_CAPSULE_NOTE_STARTED
});

export const deleteCapsuleNoteSuccess = serverReport => ({
    type: DELETE_CAPSULE_NOTE_SUCCESS,
    payload: serverReport
});

export const deleteCapsuleNoteFailure = error => ({
    type: DELETE_CAPSULE_NOTE_FAILURE,
    payload: error
});


// Загрузка файла идёт напрямую в S3, поэтому берём отдельный инстанс:
// глобальные перехватчики дописывают ?lang=… к url, а подписанная ссылка
// этого не переживает — подпись считается вместе со строкой запроса
const s3Client = axios.create();

// axios.create() копирует defaults родителя, а там Accept и
// Content-Type: application/x-www-form-urlencoded для PUT. Подпись presign
// считается ровно по заголовкам из upload.headers, поэтому любой лишний или
// подменённый заголовок даёт 403 SignatureDoesNotMatch — в браузере это
// выглядит как ошибка CORS, потому что в ответе 403 нет CORS-заголовков.
// Перехватчиков у нового инстанса нет, так что ни ?lang=, ни Authorization
// на S3 не улетят
s3Client.defaults.headers = {
    common: {},
    get: {},
    head: {},
    post: {},
    put: {},
    patch: {},
    delete: {}
};
// тело — File, трогать его не нужно
s3Client.defaults.transformRequest = [(data) => data];
s3Client.defaults.withCredentials = false;

// Браузер не даёт выставить эти заголовки, но axios успевает положить их
// в Access-Control-Request-Headers и уронить preflight
const S3_FORBIDDEN_HEADERS = ['host', 'content-length', 'connection', 'origin', 'referer'];

const s3HeadersHandler = (headers, file) => {
    const result = {};

    Object.keys(headers || {}).forEach((key) => {
        if (S3_FORBIDDEN_HEADERS.indexOf(key.toLowerCase()) === -1) {
            result[key] = headers[key];
        }
    });

    // Content-Type обязателен — он входит в подпись и должен совпадать
    // с mime, который отправляли на пресайне
    if (!Object.keys(result).some(key => key.toLowerCase() === 'content-type')) {
        result['Content-Type'] = file?.type;
    }

    return result;
};

export const getCapsuleFiles = () => {
    let url = host + api.cabinet.capsuleFiles;

    return dispatch => {
        dispatch(getCapsuleFilesStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getCapsuleFilesSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getCapsuleFilesFailure(err));
            });
    };
};

const getCapsuleFilesStarted = () => ({
    type: GET_CAPSULE_FILES_STARTED
});

export const getCapsuleFilesSuccess = serverReport => ({
    type: GET_CAPSULE_FILES_SUCCESS,
    payload: serverReport
});

export const getCapsuleFilesFailure = error => ({
    type: GET_CAPSULE_FILES_FAILURE,
    payload: error
});


export const setCapsuleFileUploadProgress = data => ({
    type: SET_CAPSULE_FILE_UPLOAD_PROGRESS,
    payload: data
});


// Три шага: presign -> PUT в S3 -> complete. Сжатие на бэке асинхронное,
// поэтому после complete файл ещё какое-то время в статусе processing
export const uploadCapsuleFile = (file, compress = true, successHandler) => {
    let url = host + api.cabinet.capsuleFiles;

    return dispatch => {
        dispatch(uploadCapsuleFileStarted());
        dispatch(setCapsuleFileUploadProgress({
            name: file?.name,
            percent: 0,
            loaded: 0,
            total: file?.size
        }));

        // На каком шаге оборвались — решает, убирать ли созданную запись:
        // после неудачного put на S3 ничего не лежит и чистить её безопасно,
        // а вот если не прошёл только complete, объект уже залит, и запись
        // нужно оставить пользователю
        let stage = 'create';
        let createdId = false;

        axios.post(url, {
            name: file?.name,
            mime: file?.type,
            size: file?.size,
            // сжимать файл в фоне или хранить как есть — выбор пользователя
            compress: !!compress
        }, headWT())
            .then(res => {
                const created = res?.data?.response?.file;
                const upload = res?.data?.response?.upload;

                stage = 'put';
                createdId = created?.id;

                return s3Client.put(upload?.url, file, {
                    headers: s3HeadersHandler(upload?.headers, file),
                    onUploadProgress: (event) => {
                        const total = event?.total || file?.size || 0;
                        dispatch(setCapsuleFileUploadProgress({
                            name: file?.name,
                            percent: total ? Math.round((event?.loaded * 100) / total) : 0,
                            loaded: event?.loaded,
                            total
                        }));
                    }
                }).then(() => {
                    stage = 'complete';
                    return axios.post(url + `/${created?.id}/complete`, null, headWT());
                });
            })
            .then(res => {
                dispatch(uploadCapsuleFileSuccess(res?.data?.response));
                dispatch(setCapsuleFileUploadProgress(false));
                dispatch(getCapsuleFiles());
                dispatch(getCapsuleStats());
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                // при ошибке CORS/сети response нет вовсе — показываем хотя бы message
                dispatch(uploadCapsuleFileFailure(err?.response?.data || {message: err?.message}));
                dispatch(setCapsuleFileUploadProgress(false));

                // пустая запись в pending_upload иначе останется в списке файлом,
                // которого нет: место в лимите не занимает, а выглядит как файл
                if (stage === 'put' && createdId){
                    dispatch(deleteCapsuleFile(createdId));
                    return;
                }
                dispatch(getCapsuleFiles());
            });
    };
};

const uploadCapsuleFileStarted = () => ({
    type: UPLOAD_CAPSULE_FILE_STARTED
});

export const uploadCapsuleFileSuccess = serverReport => ({
    type: UPLOAD_CAPSULE_FILE_SUCCESS,
    payload: serverReport
});

export const uploadCapsuleFileFailure = error => ({
    type: UPLOAD_CAPSULE_FILE_FAILURE,
    payload: error
});


export const deleteCapsuleFile = (id, successHandler) => {
    let url = host + api.cabinet.capsuleFiles + `/${id}`;

    return dispatch => {
        dispatch(deleteCapsuleFileStarted());
        axios.delete(url, headWT())
            .then(res => {
                dispatch(deleteCapsuleFileSuccess(res?.data?.response));
                dispatch(getCapsuleFiles());
                dispatch(getCapsuleStats());
                if (successHandler) {
                    successHandler();
                }
            })
            .catch(err => {
                dispatch(deleteCapsuleFileFailure(err?.response?.data));
            });
    };
};

const deleteCapsuleFileStarted = () => ({
    type: DELETE_CAPSULE_FILE_STARTED
});

export const deleteCapsuleFileSuccess = serverReport => ({
    type: DELETE_CAPSULE_FILE_SUCCESS,
    payload: serverReport
});

export const deleteCapsuleFileFailure = error => ({
    type: DELETE_CAPSULE_FILE_FAILURE,
    payload: error
});


// Цена капсулы и внутренний баланс — всё для экрана покупки в одном запросе
export const getCapsuleOffer = () => {
    let url = host + api.cabinet.capsuleOffer;

    return dispatch => {
        dispatch(getCapsuleOfferStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getCapsuleOfferSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getCapsuleOfferFailure(err));
            });
    };
};

const getCapsuleOfferStarted = () => ({
    type: GET_CAPSULE_OFFER_STARTED
});

export const getCapsuleOfferSuccess = serverReport => ({
    type: GET_CAPSULE_OFFER_SUCCESS,
    payload: serverReport
});

export const getCapsuleOfferFailure = error => ({
    type: GET_CAPSULE_OFFER_FAILURE,
    payload: error
});


// Списание с внутреннего баланса и перевод капсулы locked -> open.
// Статистику капсулы намеренно не обновляем здесь: экран успеха живёт в модалке,
// а её размонтирует сразу же, как только страница узнает, что капсула открыта
export const purchaseCapsule = (successHandler, errorHandler) => {
    let url = host + api.cabinet.capsulePurchase;

    return dispatch => {
        dispatch(purchaseCapsuleStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(purchaseCapsuleSuccess(res?.data?.response));
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch(purchaseCapsuleFailure(err?.response?.data));
                if (errorHandler) {
                    errorHandler(err?.response?.data);
                }
            });
    };
};

const purchaseCapsuleStarted = () => ({
    type: PURCHASE_CAPSULE_STARTED
});

export const purchaseCapsuleSuccess = serverReport => ({
    type: PURCHASE_CAPSULE_SUCCESS,
    payload: serverReport
});

export const purchaseCapsuleFailure = error => ({
    type: PURCHASE_CAPSULE_FAILURE,
    payload: error
});


// ---------------------------------------------------------------------------
// Главная кабинета: сводка и пополнение внутреннего баланса
// ---------------------------------------------------------------------------

export const setTopUpModalStatus = data => ({
    type: SET_TOPUP_MODAL_STATUS,
    payload: data
});


// Всё, что показывает главная, приходит одним запросом
export const getDashboard = () => {
    let url = host + api.cabinet.dashboard;

    return dispatch => {
        dispatch(getDashboardStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getDashboardSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getDashboardFailure(err));
            });
    };
};

const getDashboardStarted = () => ({
    type: GET_DASHBOARD_STARTED
});

export const getDashboardSuccess = serverReport => ({
    type: GET_DASHBOARD_SUCCESS,
    payload: serverReport
});

export const getDashboardFailure = error => ({
    type: GET_DASHBOARD_FAILURE,
    payload: error
});


// Счёт на пополнение: баланс зачисляет вебхук шлюза, поэтому дальше
// остаётся только опрашивать статус
export const createTopUp = (amount, successHandler) => {
    let url = host + api.cabinet.balanceTopup;

    return dispatch => {
        dispatch(createTopUpStarted());
        axios.post(url, {amount}, headWT())
            .then(res => {
                dispatch(createTopUpSuccess(res?.data?.response));
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch(createTopUpFailure(err?.response?.data));
            });
    };
};

const createTopUpStarted = () => ({
    type: CREATE_TOPUP_STARTED
});

export const createTopUpSuccess = serverReport => ({
    type: CREATE_TOPUP_SUCCESS,
    payload: serverReport
});

export const createTopUpFailure = error => ({
    type: CREATE_TOPUP_FAILURE,
    payload: error
});


export const getTopUpStatus = (id, successHandler) => {
    let url = host + api.cabinet.balanceTopup + `/${id}/status`;

    return dispatch => {
        dispatch(getTopUpStatusStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getTopUpStatusSuccess(res?.data?.response));
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch(getTopUpStatusFailure(err?.response?.data));
            });
    };
};

const getTopUpStatusStarted = () => ({
    type: GET_TOPUP_STATUS_STARTED
});

export const getTopUpStatusSuccess = serverReport => ({
    type: GET_TOPUP_STATUS_SUCCESS,
    payload: serverReport
});

export const getTopUpStatusFailure = error => ({
    type: GET_TOPUP_STATUS_FAILURE,
    payload: error
});


export const cancelTopUp = (id, successHandler) => {
    let url = host + api.cabinet.balanceTopup + `/${id}/cancel`;

    return dispatch => {
        dispatch(cancelTopUpStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(cancelTopUpSuccess(res?.data?.response));
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch(cancelTopUpFailure(err?.response?.data));
            });
    };
};

const cancelTopUpStarted = () => ({
    type: CANCEL_TOPUP_STARTED
});

export const cancelTopUpSuccess = serverReport => ({
    type: CANCEL_TOPUP_SUCCESS,
    payload: serverReport
});

export const cancelTopUpFailure = error => ({
    type: CANCEL_TOPUP_FAILURE,
    payload: error
});


// Обновления публичные и многоязычные. lang передаём явно — так он совпадает
// с языком интерфейса; перехватчик свой ?lang= не дописывает, если он уже есть
export const getSystemUpdates = (page = 1, perPage = 10, lang) => {
    let url = host + api.systemUpdates + `?page=${page}&per_page=${perPage}`;

    if (lang) {
        url += `&lang=${lang}`;
    }

    return dispatch => {
        dispatch(getSystemUpdatesStarted());
        axios.get(url)
            .then(res => {
                dispatch(getSystemUpdatesSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getSystemUpdatesFailure(err));
            });
    };
};

const getSystemUpdatesStarted = () => ({
    type: GET_SYSTEM_UPDATES_STARTED
});

export const getSystemUpdatesSuccess = serverReport => ({
    type: GET_SYSTEM_UPDATES_SUCCESS,
    payload: serverReport
});

export const getSystemUpdatesFailure = error => ({
    type: GET_SYSTEM_UPDATES_FAILURE,
    payload: error
});


// ---------------------------------------------------------------------------
// Прямое пополнение баланса ончейн: пользователь сам отправляет перевод
// со своего кошелька, мы 30 минут ищем его в сети
// ---------------------------------------------------------------------------

export const getDirectTopUpInfo = () => {
    let url = host + api.cabinet.directTopup + '/info';

    return dispatch => {
        dispatch(getDirectTopUpInfoStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getDirectTopUpInfoSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getDirectTopUpInfoFailure(err?.response?.data));
            });
    };
};

const getDirectTopUpInfoStarted = () => ({
    type: GET_DIRECT_TOPUP_INFO_STARTED
});

export const getDirectTopUpInfoSuccess = serverReport => ({
    type: GET_DIRECT_TOPUP_INFO_SUCCESS,
    payload: serverReport
});

export const getDirectTopUpInfoFailure = error => ({
    type: GET_DIRECT_TOPUP_INFO_FAILURE,
    payload: error
});


export const createDirectTopUp = (data, successHandler) => {
    let url = host + api.cabinet.directTopup;

    return dispatch => {
        dispatch(createDirectTopUpStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(createDirectTopUpSuccess(res?.data?.response?.topup));
                if (successHandler) {
                    successHandler(res?.data?.response?.topup);
                }
            })
            .catch(err => {
                dispatch(createDirectTopUpFailure(err?.response?.data));
            });
    };
};

const createDirectTopUpStarted = () => ({
    type: CREATE_DIRECT_TOPUP_STARTED
});

export const createDirectTopUpSuccess = serverReport => ({
    type: CREATE_DIRECT_TOPUP_SUCCESS,
    payload: serverReport
});

export const createDirectTopUpFailure = error => ({
    type: CREATE_DIRECT_TOPUP_FAILURE,
    payload: error
});


// Сервер пересканирует цепочку не чаще раза в 15 секунд на заявку,
// поэтому чаще опрашивать смысла нет
export const getDirectTopUp = (id, successHandler) => {
    let url = host + api.cabinet.directTopup + `/${id}`;

    return dispatch => {
        dispatch(getDirectTopUpStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getDirectTopUpSuccess(res?.data?.response?.topup));
                if (successHandler) {
                    successHandler(res?.data?.response?.topup);
                }
            })
            .catch(err => {
                dispatch(getDirectTopUpFailure(err?.response?.data));
            });
    };
};

const getDirectTopUpStarted = () => ({
    type: GET_DIRECT_TOPUP_STARTED
});

export const getDirectTopUpSuccess = serverReport => ({
    type: GET_DIRECT_TOPUP_SUCCESS,
    payload: serverReport
});

export const getDirectTopUpFailure = error => ({
    type: GET_DIRECT_TOPUP_FAILURE,
    payload: error
});


export const cancelDirectTopUp = (id, successHandler) => {
    let url = host + api.cabinet.directTopup + `/${id}/cancel`;

    return dispatch => {
        dispatch(cancelDirectTopUpStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(cancelDirectTopUpSuccess(res?.data?.response?.topup));
                if (successHandler) {
                    successHandler();
                }
            })
            .catch(err => {
                dispatch(cancelDirectTopUpFailure(err?.response?.data));
            });
    };
};

const cancelDirectTopUpStarted = () => ({
    type: CANCEL_DIRECT_TOPUP_STARTED
});

export const cancelDirectTopUpSuccess = serverReport => ({
    type: CANCEL_DIRECT_TOPUP_SUCCESS,
    payload: serverReport
});

export const cancelDirectTopUpFailure = error => ({
    type: CANCEL_DIRECT_TOPUP_FAILURE,
    payload: error
});


// ---------------------------------------------------------------------------
// Уведомления
// ---------------------------------------------------------------------------

// Фильтры и сортировка серверные: ?type=a,b&from=&to=&sort=newest|oldest&unread=1
// append — дописать к уже загруженному (подгрузка по прокрутке и «Показать ещё»)
export const getNotifications = (params = {}) => {
    const {
        page = 1,
        perPage = 20,
        unread = false,
        type = '',
        from = '',
        to = '',
        sort = '',
        append = false
    } = params;

    let url = host + api.cabinet.notifications + `?page=${page}&per_page=${perPage}`;

    if (unread) {
        url += '&unread=1';
    }
    if (type) {
        url += `&type=${encodeURIComponent(type)}`;
    }
    if (from) {
        url += `&from=${encodeURIComponent(from)}`;
    }
    if (to) {
        url += `&to=${encodeURIComponent(to)}`;
    }
    if (sort) {
        url += `&sort=${encodeURIComponent(sort)}`;
    }

    return dispatch => {
        dispatch(getNotificationsStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getNotificationsSuccess({...res?.data?.response, append}));
            })
            .catch(err => {
                dispatch(getNotificationsFailure(err?.response?.data));
            });
    };
};

const getNotificationsStarted = () => ({
    type: GET_NOTIFICATIONS_STARTED
});

export const getNotificationsSuccess = serverReport => ({
    type: GET_NOTIFICATIONS_SUCCESS,
    payload: serverReport
});

export const getNotificationsFailure = error => ({
    type: GET_NOTIFICATIONS_FAILURE,
    payload: error
});


export const readNotification = (id) => {
    let url = host + api.cabinet.notifications + `/${id}/read`;

    return dispatch => {
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(readNotificationSuccess(res?.data?.response));
            })
            .catch(() => {});
    };
};

export const readNotificationSuccess = serverReport => ({
    type: READ_NOTIFICATION_SUCCESS,
    payload: serverReport
});


export const readAllNotifications = () => {
    let url = host + api.cabinet.notifications + '/read-all';

    return dispatch => {
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(readAllNotificationsSuccess(res?.data?.response));
            })
            .catch(() => {});
    };
};

export const readAllNotificationsSuccess = serverReport => ({
    type: READ_ALL_NOTIFICATIONS_SUCCESS,
    payload: serverReport
});


// ---------------------------------------------------------------------------
// Вывод средств: баланс резервируется в момент подачи заявки
// ---------------------------------------------------------------------------

export const setWithdrawModalStatus = data => ({
    type: SET_WITHDRAW_MODAL_STATUS,
    payload: data
});


export const getWithdrawInfo = () => {
    let url = host + api.cabinet.withdrawals + '/info';

    return dispatch => {
        dispatch(getWithdrawInfoStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getWithdrawInfoSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getWithdrawInfoFailure(err?.response?.data));
            });
    };
};

const getWithdrawInfoStarted = () => ({
    type: GET_WITHDRAW_INFO_STARTED
});

export const getWithdrawInfoSuccess = serverReport => ({
    type: GET_WITHDRAW_INFO_SUCCESS,
    payload: serverReport
});

export const getWithdrawInfoFailure = error => ({
    type: GET_WITHDRAW_INFO_FAILURE,
    payload: error
});


export const createWithdraw = (data, successHandler) => {
    let url = host + api.cabinet.withdrawals;

    return dispatch => {
        dispatch(createWithdrawStarted());
        axios.post(url, data, headWT())
            .then(res => {
                dispatch(createWithdrawSuccess(res?.data?.response?.withdrawal));
                if (successHandler) {
                    successHandler(res?.data?.response?.withdrawal);
                }
            })
            .catch(err => {
                dispatch(createWithdrawFailure(err?.response?.data));
            });
    };
};

const createWithdrawStarted = () => ({
    type: CREATE_WITHDRAW_STARTED
});

export const createWithdrawSuccess = serverReport => ({
    type: CREATE_WITHDRAW_SUCCESS,
    payload: serverReport
});

export const createWithdrawFailure = error => ({
    type: CREATE_WITHDRAW_FAILURE,
    payload: error
});


export const getWithdraws = () => {
    let url = host + api.cabinet.withdrawals;

    return dispatch => {
        dispatch(getWithdrawsStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getWithdrawsSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getWithdrawsFailure(err?.response?.data));
            });
    };
};

const getWithdrawsStarted = () => ({
    type: GET_WITHDRAWS_STARTED
});

export const getWithdrawsSuccess = serverReport => ({
    type: GET_WITHDRAWS_SUCCESS,
    payload: serverReport
});

export const getWithdrawsFailure = error => ({
    type: GET_WITHDRAWS_FAILURE,
    payload: error
});


export const cancelWithdraw = (id, successHandler) => {
    let url = host + api.cabinet.withdrawals + `/${id}/cancel`;

    return dispatch => {
        dispatch(cancelWithdrawStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(cancelWithdrawSuccess(res?.data?.response?.withdrawal));
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch(cancelWithdrawFailure(err?.response?.data));
            });
    };
};

const cancelWithdrawStarted = () => ({
    type: CANCEL_WITHDRAW_STARTED
});

export const cancelWithdrawSuccess = serverReport => ({
    type: CANCEL_WITHDRAW_SUCCESS,
    payload: serverReport
});

export const cancelWithdrawFailure = error => ({
    type: CANCEL_WITHDRAW_FAILURE,
    payload: error
});


// ---------------------------------------------------------------------------
// Перевод вознаграждений: referral_balance → balance. Сумма резервируется
// сразу при подаче заявки, админ её подтверждает или отклоняет
// ---------------------------------------------------------------------------

export const setReferralTransferModalStatus = data => ({
    type: SET_REFERRAL_TRANSFER_MODAL_STATUS,
    payload: data
});

export const setReferralTransfersModalStatus = data => ({
    type: SET_REFERRAL_TRANSFERS_MODAL_STATUS,
    payload: data
});


export const getReferralTransfers = () => {
    let url = host + api.cabinet.referralTransfers;

    return dispatch => {
        dispatch(getReferralTransfersStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getReferralTransfersSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getReferralTransfersFailure(err?.response?.data));
            });
    };
};

const getReferralTransfersStarted = () => ({
    type: GET_REFERRAL_TRANSFERS_STARTED
});

export const getReferralTransfersSuccess = serverReport => ({
    type: GET_REFERRAL_TRANSFERS_SUCCESS,
    payload: serverReport
});

export const getReferralTransfersFailure = error => ({
    type: GET_REFERRAL_TRANSFERS_FAILURE,
    payload: error
});


// POST /user/referral-transfers убран с API 22 (405): новые переводы на
// основной баланс не создаются, вывод идёт через createReferralWithdraw

export const cancelReferralTransfer = (id, successHandler) => {
    let url = host + api.cabinet.referralTransfers + `/${id}/cancel`;

    return dispatch => {
        dispatch(cancelReferralTransferStarted());
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(cancelReferralTransferSuccess(res?.data?.response));
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch(cancelReferralTransferFailure(err?.response?.data));
            });
    };
};

const cancelReferralTransferStarted = () => ({
    type: CANCEL_REFERRAL_TRANSFER_STARTED
});

export const cancelReferralTransferSuccess = serverReport => ({
    type: CANCEL_REFERRAL_TRANSFER_SUCCESS,
    payload: serverReport
});

export const cancelReferralTransferFailure = error => ({
    type: CANCEL_REFERRAL_TRANSFER_FAILURE,
    payload: error
});


// ---------------------------------------------------------------------------
// Вывод реферального баланса.
// С API 22 вознаграждения не переводятся на основной баланс, а выводятся
// в сеть тем же флоу, что и обычный вывод, только по своему префиксу и из
// отдельного кошелька. Перевод на основной баланс остался только легаси:
// создать новый нельзя, старые заявки можно увидеть и отменить
// ---------------------------------------------------------------------------

export const setReferralWithdrawModalStatus = data => ({
    type: SET_REFERRAL_WITHDRAW_MODAL_STATUS,
    payload: data
});


export const getReferralWithdrawInfo = () => {
    let url = host + api.cabinet.referralWithdrawals + '/info';

    return dispatch => {
        dispatch({type: GET_REFERRAL_WITHDRAW_INFO_STARTED});
        axios.get(url, headWT())
            .then(res => {
                dispatch({type: GET_REFERRAL_WITHDRAW_INFO_SUCCESS, payload: res?.data?.response});
            })
            .catch(err => {
                dispatch({type: GET_REFERRAL_WITHDRAW_INFO_FAILURE, payload: err?.response?.data});
            });
    };
};


export const createReferralWithdraw = (data, successHandler) => {
    let url = host + api.cabinet.referralWithdrawals;

    return dispatch => {
        dispatch({type: CREATE_REFERRAL_WITHDRAW_STARTED});
        axios.post(url, data, headWT())
            .then(res => {
                dispatch({type: CREATE_REFERRAL_WITHDRAW_SUCCESS, payload: res?.data?.response?.withdrawal});
                if (successHandler) {
                    successHandler(res?.data?.response?.withdrawal);
                }
            })
            .catch(err => {
                dispatch({type: CREATE_REFERRAL_WITHDRAW_FAILURE, payload: err?.response?.data});
            });
    };
};

export const createReferralWithdrawFailure = error => ({
    type: CREATE_REFERRAL_WITHDRAW_FAILURE,
    payload: error
});


export const getReferralWithdraws = () => {
    let url = host + api.cabinet.referralWithdrawals;

    return dispatch => {
        dispatch({type: GET_REFERRAL_WITHDRAWS_STARTED});
        axios.get(url, headWT())
            .then(res => {
                dispatch({type: GET_REFERRAL_WITHDRAWS_SUCCESS, payload: res?.data?.response});
            })
            .catch(err => {
                dispatch({type: GET_REFERRAL_WITHDRAWS_FAILURE, payload: err?.response?.data});
            });
    };
};


export const cancelReferralWithdraw = (id, successHandler) => {
    let url = host + api.cabinet.referralWithdrawals + `/${id}/cancel`;

    return dispatch => {
        dispatch({type: CANCEL_REFERRAL_WITHDRAW_STARTED});
        axios.post(url, null, headWT())
            .then(res => {
                dispatch({type: CANCEL_REFERRAL_WITHDRAW_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: CREATE_REFERRAL_WITHDRAW_FAILURE, payload: err?.response?.data});
            });
    };
};


// ---------------------------------------------------------------------------
// Аватар: 3D-модель (GLB) для кабинета
// ---------------------------------------------------------------------------

// model_url — подписанная ссылка со сроком жизни (по умолчанию 30 минут).
// Её нельзя сохранять и переиспользовать: перед каждой загрузкой модели
// запрашиваем /avatar заново
export const getAvatar = () => {
    let url = host + api.cabinet.avatar;

    return dispatch => {
        dispatch(getAvatarStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getAvatarSuccess(res?.data?.response?.avatar || null));
            })
            .catch(err => {
                dispatch(getAvatarFailure(err?.response?.data));
            });
    };
};

const getAvatarStarted = () => ({
    type: GET_AVATAR_STARTED
});

export const getAvatarSuccess = serverReport => ({
    type: GET_AVATAR_SUCCESS,
    payload: serverReport
});

export const getAvatarFailure = error => ({
    type: GET_AVATAR_FAILURE,
    payload: error
});


// ---------------------------------------------------------------------------
// Голос: запись клонируется на сервере, отправить можно только один раз
// ---------------------------------------------------------------------------

export const getVoice = () => {
    let url = host + api.cabinet.voice;

    return dispatch => {
        dispatch(getVoiceStarted());
        axios.get(url, headWT())
            .then(res => {
                dispatch(getVoiceSuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch(getVoiceFailure(err?.response?.data));
            });
    };
};

const getVoiceStarted = () => ({
    type: GET_VOICE_STARTED
});

export const getVoiceSuccess = serverReport => ({
    type: GET_VOICE_SUCCESS,
    payload: serverReport
});

export const getVoiceFailure = error => ({
    type: GET_VOICE_FAILURE,
    payload: error
});


// clip — File или Blob из <input type="file"> либо из MediaRecorder.
// Запрос блокирующий: сервер ждёт, пока голос склонируется
export const uploadVoice = (clip, successHandler) => {
    let url = host + api.cabinet.voice;

    const data = new FormData();
    data.append('clip', clip, clip?.name || 'voice.webm');

    return dispatch => {
        dispatch(uploadVoiceStarted());
        axios.post(url, data, headWTFD())
            .then(res => {
                dispatch(uploadVoiceSuccess(res?.data?.response));
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch(uploadVoiceFailure(err?.response?.data || {message: err?.message}));
            });
    };
};

const uploadVoiceStarted = () => ({
    type: UPLOAD_VOICE_STARTED
});

export const uploadVoiceSuccess = serverReport => ({
    type: UPLOAD_VOICE_SUCCESS,
    payload: serverReport
});

export const uploadVoiceFailure = error => ({
    type: UPLOAD_VOICE_FAILURE,
    payload: error
});


// ---------------------------------------------------------------------------
// Энергия: одна оплата открывает и аватар, и голос
// ---------------------------------------------------------------------------

export const setUnlockModalStatus = data => ({type: SET_UNLOCK_MODAL_STATUS, payload: data});
export const setEnergyModalStatus = data => ({type: SET_ENERGY_MODAL_STATUS, payload: data});
export const setCreatorStatus = data => ({type: SET_CREATOR_STATUS, payload: data});


export const getEnergy = () => {
    let url = host + api.cabinet.energy;

    return dispatch => {
        dispatch({type: GET_ENERGY_STARTED});
        axios.get(url, headWT())
            .then(res => {
                dispatch(getEnergySuccess(res?.data?.response));
            })
            .catch(err => {
                dispatch({type: GET_ENERGY_FAILURE, payload: err?.response?.data});
            });
    };
};

export const getEnergySuccess = serverReport => ({
    type: GET_ENERGY_SUCCESS,
    payload: serverReport
});


export const unlockEnergy = (successHandler) => {
    let url = host + api.cabinet.energyUnlock;

    return dispatch => {
        dispatch({type: UNLOCK_ENERGY_STARTED});
        axios.post(url, null, headWT())
            .then(res => {
                dispatch(getEnergySuccess(res?.data?.response));
                dispatch({type: UNLOCK_ENERGY_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch(unlockEnergyFailure(err?.response?.data || {message: err?.message}));
            });
    };
};

export const unlockEnergyFailure = error => ({
    type: UNLOCK_ENERGY_FAILURE,
    payload: error
});


// ---------------------------------------------------------------------------
// MetaPerson Creator: сессия для iframe и импорт готового GLB
// ---------------------------------------------------------------------------

// access_token живёт часы, но сессию берём заново на каждое открытие окна
export const getMetapersonSession = () => {
    let url = host + api.cabinet.metapersonSession;

    return dispatch => {
        dispatch({type: GET_METAPERSON_STARTED});
        axios.get(url, headWT())
            .then(res => {
                dispatch({type: GET_METAPERSON_SUCCESS, payload: res?.data?.response});
            })
            .catch(err => {
                dispatch({type: GET_METAPERSON_FAILURE, payload: err?.response?.data || {message: err?.message}});
            });
    };
};

// Сначала пытаемся скачать экспорт в браузере и отдать файлом — так надёжнее.
// Если провайдер закрыл CORS, отдаём серверу ссылку, он скачает сам
export const importAvatar = (exportUrl, avatarCode, successHandler) => {
    let url = host + api.cabinet.avatarImport;

    return async dispatch => {
        dispatch({type: IMPORT_AVATAR_STARTED});

        const data = new FormData();
        if (avatarCode) {
            data.append('avatar_code', avatarCode);
        }

        try {
            const res = await fetch(exportUrl);
            if (!res.ok) {
                throw new Error('export fetch failed');
            }
            const blob = await res.blob();
            data.append('glb', blob, 'avatar.glb');
        } catch (e) {
            data.append('url', exportUrl);
        }

        axios.post(url, data, headWTFD())
            .then(res => {
                dispatch(importAvatarSuccess(res?.data?.response?.avatar || null));
                if (successHandler) {
                    successHandler(res?.data?.response?.avatar);
                }
            })
            .catch(err => {
                dispatch(importAvatarFailure(err?.response?.data || {message: err?.message}));
            });
    };
};

export const importAvatarSuccess = serverReport => ({
    type: IMPORT_AVATAR_SUCCESS,
    payload: serverReport
});

export const importAvatarFailure = error => ({
    type: IMPORT_AVATAR_FAILURE,
    payload: error
});


// ---------------------------------------------------------------------------
// Покупка энергии.
// Энергия покупается криптой через платёжный шлюз — тот же флоу, что у
// пополнения баланса: создаём счёт, показываем payment_options у себя и
// опрашиваем статус. Сама энергия начисляется вебхуком при оплате, а не
// этими запросами; после зачисления приходит уведомление energy_purchased.
// ---------------------------------------------------------------------------

export const getEnergyPackages = () => {
    let url = host + api.cabinet.energyPackages;

    return dispatch => {
        dispatch({type: GET_ENERGY_PACKAGES_STARTED});
        axios.get(url, headWT())
            .then(res => {
                dispatch({type: GET_ENERGY_PACKAGES_SUCCESS, payload: res?.data?.response});
            })
            .catch(err => {
                dispatch({type: GET_ENERGY_PACKAGES_FAILURE, payload: err?.response?.data});
            });
    };
};

// data — ровно одно из полей: {package_id} или {energy}
export const createEnergyPurchase = (data, successHandler, failHandler) => {
    let url = host + api.cabinet.energyPurchase;

    return dispatch => {
        dispatch({type: CREATE_ENERGY_PURCHASE_STARTED});
        axios.post(url, data, headWT())
            .then(res => {
                dispatch({type: CREATE_ENERGY_PURCHASE_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: CREATE_ENERGY_PURCHASE_FAILURE, payload: err?.response?.data});
                if (failHandler) {
                    failHandler(err?.response?.data);
                }
            });
    };
};

// Статус опрашивается по таймеру: разовый сбой сети не должен показывать
// ошибку пользователю — следующая попытка через 15 секунд
export const getEnergyPurchaseStatus = (id, successHandler, failHandler) => {
    let url = host + api.cabinet.energyPurchase + `/${id}/status`;

    return dispatch => {
        axios.get(url, headWT())
            .then(res => {
                dispatch({type: GET_ENERGY_PURCHASE_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                // фоновому опросу ошибка не важна — он просто попробует ещё раз,
                // а вот ручной проверке нужно знать, что ответа не было
                if (failHandler) {
                    failHandler(err?.response?.data);
                }
            });
    };
};

export const cancelEnergyPurchase = (id, successHandler, failHandler) => {
    let url = host + api.cabinet.energyPurchase + `/${id}/cancel`;

    return dispatch => {
        axios.post(url, null, headWT())
            .then(res => {
                dispatch({type: CANCEL_ENERGY_PURCHASE_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                // 409 — счёт уже оплачен или закрыт: молча ничего не делать нельзя,
                // иначе кнопка выглядит сломанной
                dispatch({type: CREATE_ENERGY_PURCHASE_FAILURE, payload: err?.response?.data});
                if (failHandler) {
                    failHandler(err?.response?.data);
                }
            });
    };
};


// ---------------------------------------------------------------------------
// Заявка на участие в альфа-тесте.
// Пока статус не granted, кабинет закрыт: вместо него страница с заявкой.
// Запрос идемпотентный — повторный вызов просто возвращает текущий статус
// ---------------------------------------------------------------------------

export const requestEarlyAccess = (successHandler) => {
    let url = host + api.cabinet.earlyAccess;

    return dispatch => {
        dispatch({type: REQUEST_EARLY_ACCESS_STARTED});
        axios.post(url, null, headWT())
            .then(res => {
                dispatch({type: REQUEST_EARLY_ACCESS_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: REQUEST_EARLY_ACCESS_FAILURE, payload: err?.response?.data});
            });
    };
};


// ---------------------------------------------------------------------------
// Покупка места в хранилище.
// Пакеты (ГБ на срок) оплачиваются криптой через тот же шлюз, что энергия:
// создаём счёт, показываем реквизиты у себя и опрашиваем статус. Место
// добавляет вебхук при оплате, после чего приходит storage_purchased.
// Пакеты срочные: у каждого свой ends_at, по истечении квота уменьшается,
// но файлы не удаляются — просто нельзя загружать новые
// ---------------------------------------------------------------------------

export const setStorageModalStatus = data => ({
    type: SET_STORAGE_MODAL_STATUS,
    payload: data
});


export const getStorage = () => {
    let url = host + api.cabinet.storage;

    return dispatch => {
        dispatch({type: GET_STORAGE_STARTED});
        axios.get(url, headWT())
            .then(res => {
                dispatch({type: GET_STORAGE_SUCCESS, payload: res?.data?.response});
            })
            .catch(err => {
                dispatch({type: GET_STORAGE_FAILURE, payload: err?.response?.data});
            });
    };
};


export const getStoragePackages = () => {
    let url = host + api.cabinet.storagePackages;

    return dispatch => {
        dispatch({type: GET_STORAGE_PACKAGES_STARTED});
        axios.get(url, headWT())
            .then(res => {
                dispatch({type: GET_STORAGE_PACKAGES_SUCCESS, payload: res?.data?.response});
            })
            .catch(err => {
                dispatch({type: GET_STORAGE_PACKAGES_FAILURE, payload: err?.response?.data});
            });
    };
};


export const createStoragePurchase = (packageId, successHandler, failHandler) => {
    let url = host + api.cabinet.storagePurchase;

    return dispatch => {
        dispatch({type: CREATE_STORAGE_PURCHASE_STARTED});
        axios.post(url, {package_id: packageId}, headWT())
            .then(res => {
                dispatch({type: CREATE_STORAGE_PURCHASE_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: CREATE_STORAGE_PURCHASE_FAILURE, payload: err?.response?.data});
                if (failHandler) {
                    failHandler(err?.response?.data);
                }
            });
    };
};


// Статус опрашивается по таймеру: разовый сбой сети не должен показывать
// ошибку пользователю — следующая попытка через 15 секунд
export const getStoragePurchaseStatus = (id, successHandler, failHandler) => {
    let url = host + api.cabinet.storagePurchase + `/${id}/status`;

    return dispatch => {
        axios.get(url, headWT())
            .then(res => {
                dispatch({type: GET_STORAGE_PURCHASE_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                if (failHandler) {
                    failHandler(err?.response?.data);
                }
            });
    };
};


export const cancelStoragePurchase = (id, successHandler, failHandler) => {
    let url = host + api.cabinet.storagePurchase + `/${id}/cancel`;

    return dispatch => {
        axios.post(url, null, headWT())
            .then(res => {
                dispatch({type: CANCEL_STORAGE_PURCHASE_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                // 409 — счёт уже оплачен или закрыт
                dispatch({type: CREATE_STORAGE_PURCHASE_FAILURE, payload: err?.response?.data});
                if (failHandler) {
                    failHandler(err?.response?.data);
                }
            });
    };
};


// ---------------------------------------------------------------------------
// Диалог с цифровой копией.
// С API 20 чат у пользователя один, и контекст держит сервер: history он
// принимает только до появления чата, то есть на самый первый вопрос.
// Списание энергии считается по факту и приходит в ответе (energy_charged),
// но перед запросом сервер удерживает его максимально возможную стоимость —
// при нехватке приходит 422 errors.energy с нужной и доступной суммой.
// ---------------------------------------------------------------------------

// data: {conversationId, question} либо {conversationId, clip}, плюс history
export const askConversation = (data, successHandler, failHandler) => {
    let url = host + api.cabinet.conversationAsk;
    const {conversationId, question, clip, history = []} = data;

    return dispatch => {
        dispatch({type: ASK_CONVERSATION_STARTED});

        let body;
        let config;

        if (clip){
            // голосовой вопрос: multipart, history — строкой JSON
            body = new FormData();
            body.append('clip', clip, clip.name || 'question.webm');
            if (conversationId) body.append('conversation_id', conversationId);
            if (history.length) body.append('history', JSON.stringify(history));
            config = headWTFD();
        } else {
            body = {question, history};
            if (conversationId) body.conversation_id = conversationId;
            config = headWT();
        }

        axios.post(url, body, config)
            .then(res => {
                dispatch({type: ASK_CONVERSATION_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: ASK_CONVERSATION_FAILURE, payload: err?.response?.data});
                if (failHandler) {
                    failHandler(err?.response?.data, err?.response?.status);
                }
            });
    };
};

// Отдаёт не JSON, а байты mp3; расход энергии — в заголовках ответа
export const speakConversation = (data, successHandler, failHandler) => {
    let url = host + api.cabinet.conversationSpeak;
    const {text, conversationId, messageId} = data;

    const body = {text};
    if (conversationId) body.conversation_id = conversationId;
    if (messageId) body.message_id = messageId;

    return dispatch => {
        dispatch({type: SPEAK_CONVERSATION_STARTED});
        axios.post(url, body, {...headWT(), responseType: 'blob'})
            .then(res => {
                const charged = res?.headers?.['x-energy-charged'];
                const left = res?.headers?.['x-energy'];
                dispatch({type: SPEAK_CONVERSATION_SUCCESS, payload: left});
                if (successHandler) {
                    successHandler(res?.data, charged, left);
                }
            })
            .catch(err => {
                dispatch({type: SPEAK_CONVERSATION_FAILURE, payload: true});

                if (!failHandler) {
                    return;
                }

                // ответ запрошен блобом, поэтому и тело ошибки приходит блобом:
                // чтобы показать причину (мало энергии, нет голоса, длинный
                // текст), его нужно сначала прочитать и разобрать
                const status = err?.response?.status;
                const data = err?.response?.data;

                if (data && typeof data.text === 'function') {
                    data.text()
                        .then(text => {
                            let parsed = false;
                            try {
                                parsed = JSON.parse(text);
                            } catch (e) {
                                parsed = false;
                            }
                            failHandler(parsed, status);
                        })
                        .catch(() => { failHandler(false, status); });
                    return;
                }

                failHandler(data, status);
            });
    };
};

export const getConversations = (page = 1, perPage = 20, successHandler) => {
    let url = host + api.cabinet.conversations + `?page=${page}&per_page=${perPage}`;

    return dispatch => {
        dispatch({type: GET_CONVERSATIONS_STARTED});
        axios.get(url, headWT())
            .then(res => {
                dispatch({type: GET_CONVERSATIONS_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: GET_CONVERSATIONS_FAILURE, payload: err?.response?.data});
            });
    };
};

export const getConversation = (id, successHandler, failHandler) => {
    let url = host + api.cabinet.conversations + `/${id}`;

    return dispatch => {
        dispatch({type: GET_CONVERSATION_STARTED});
        axios.get(url, headWT())
            .then(res => {
                dispatch({type: GET_CONVERSATION_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: GET_CONVERSATION_FAILURE, payload: err?.response?.data});
                if (failHandler) {
                    failHandler(err?.response?.data);
                }
            });
    };
};


// Закрытие капсулы необратимо — подтверждение обязательно на стороне UI
export const sealCapsule = (successHandler, failHandler) => {
    let url = host + api.cabinet.capsuleSeal;

    return dispatch => {
        dispatch({type: SEAL_CAPSULE_STARTED});
        axios.post(url, null, headWT())
            .then(res => {
                dispatch({type: SEAL_CAPSULE_SUCCESS, payload: res?.data?.response});
                if (successHandler) {
                    successHandler(res?.data?.response);
                }
            })
            .catch(err => {
                dispatch({type: SEAL_CAPSULE_FAILURE, payload: err?.response?.data});
                if (failHandler) {
                    failHandler(err?.response?.data);
                }
            });
    };
};

export const setSealModalStatus = status => ({
    type: SET_SEAL_MODAL_STATUS,
    payload: status
});
